import { Component, ElementRef, Input, LOCALE_ID, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatAccordion, MatExpansionPanel } from "@angular/material/expansion";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { AppDateAdapter, APP_FORMATOS_FECHA } from "@otrosProveedoresV6/date-format.adapter";
import { MatPaginatorIntlEses } from "@otrosProveedoresV6/ES-es.paginator";
import { traspasomodelo } from "@sharedV11/classes/tarifas/traspasomodelo";
import { ListadoEnlacesMenu, ListaListado, TransformedListadoyKeyValues, Mensaje, GetCalendariosCuadrosMesLista, Idioma, ListaPlataforma } from "@sharedV11/models";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { DatosLista } from "@sharedV11/services/api/connection/conectar-api.interface";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { MicroserviceService } from "@sharedV11/services/microservices/microservice.service";
import { ListaIdiomaMicroService } from "@sharedV11/services/microservices/model";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { LISTA_PLATAFORMAS, LISTA_PLATAFORMAS_DATOS } from "@sharedV11/store";
import { getLocale } from "@sharedV11/utils/factories";
import { DualListComponent } from "angular-dual-listbox";
import moment from "moment";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit-categorias",
  templateUrl: "./edit-aviso-en-la-web.component.html",
  styleUrls: ["./edit-aviso-en-la-web.component.scss"],
})
export class EditAvisoEnLaWebComponent implements OnInit {
  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;
  @Input() otherProps: { [key: string]: string };
  @ViewChildren('expansionPanel') expansionPanelList!: QueryList<MatExpansionPanel>;

  translation: any;

  editRegistroForm: FormGroup;

  //centros
  centros: DatosLista[] = [];

  idiomas: Pick<ListaIdiomaMicroService, 'nombre' | 'codIdioma'>[] = [];
  idiomasCacheMap = new Map();

  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

	fecha_minHasta = new Date();
	fechaPC_maxHasta: Date;
	fechaFV_minDesde = new Date();
	fechaFV_minHasta = new Date();
	fechaFV_maxDesde: Date;

  model = new traspasomodelo();
  

  lineas = ['Linea1', 'Linea2', 'Linea3'];
  lineasControlNames = [];
  idiomasControlNames = [];
  lineaWithIdiomaControlNames: { linea: string; codIdioma: string; }[] = [];

  lineasWithIdioma: {
    Linea1: { linea: string; codIdioma: string; }[];
    Linea2: { linea: string; codIdioma: string; }[];
    Linea3: { linea: string; codIdioma: string; }[];
  } = {
    Linea1: [],
    Linea2: [],
    Linea3: []
  };

  isControlLinea1HasError = false;
  lineaPanelStep = 0;
  ListaPlataformas = LISTA_PLATAFORMAS;
  ListaPlataformasDatos = LISTA_PLATAFORMAS_DATOS;
  
  // Form values:
  // pkId: string;
  // FechaInicio: string;
  // FechaFin: string;
  // ClaveCentro: string;
  // NombreCentro: string;
  // Idiomas: string;
  // ListaPlataformas: string;
  // Linea1_es-ES: string; 
  // Linea1_en-GB: string; etc.
  // Linea2_es-ES: string; 
  // Linea2_en-GB: string; etc.
  // Linea3_es-ES: string; 
  // Linea3_en-GB: string; etc.
  formValues: { [key: string]: string };
  closedAccordionIndex: number = null;

  constructor(
    private fb: FormBuilder,
    private translator: Translator,
    private panelService: PanelService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private conectarApiService: ConectarApiService,
    private microService: MicroserviceService,
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.initializeTranslate();
    this.getIdiomas().then(() => {
      this.initializeFormWithoutData();
      this.addOnFormLineasBasedOnLang();
      this.getCentros();
      this.manageForm(this.pkId, this.mode);
      this.valuedChanged();
    });
  }

  initializeFormWithoutData() {
    this.editRegistroForm = this.fb.group({
      pkId: [""],
      FechaInicio: [new Date(), Validators.required],
      FechaFin: ["", Validators.required],
      NombreCentro: [""],
      ClaveCentro: [""],
      Linea1: [""],
      Linea2: [""],
      Linea3: [""],
      Idiomas: [""],
      ListaPlataformas: [['1'], Validators.required]
    });
  }

  addOnFormLineasBasedOnLang(): void {
    if (this.idiomas && this.idiomas.length) {
      this.idiomas.forEach((idioma) => {
        let currentLineaWithIdioma = [];
        this.lineas.forEach((linea) => {
          const userLang = localStorage.getItem('Language') ?? '';
          const newControl = this.fb.control('');

          if (idioma.codIdioma === userLang && linea === 'Linea1') {
            newControl.setValidators(Validators.required);
          }

          this.editRegistroForm.addControl(`${linea}_${idioma.codIdioma}`, newControl);

          currentLineaWithIdioma.push({ linea, codIdioma : idioma.codIdioma});
          this.lineasWithIdioma[linea] = currentLineaWithIdioma;
        })

      });
    }
  }

  manageForm(pkId, mode) {
    if (mode == "I") {
      this.formValues = this.editRegistroForm.value;
      this.loading = false;
    }

    if (pkId) {
      if (this.otherProps) {
        const modifiedElement: { [key: string]: string } = {
          ...this.otherProps
        }

        this.updateFormValues(modifiedElement);
        this.loading = false;
      }
    }
  }

  async getCentros(): Promise<void> {
    try {
      const response = await this.conectarApiService.getDatosListasMS({ nombreTabla: 'centros', }).toPromise();

        if (response?.datosResult && response.datosResult?.datosListas?.length) {
          this.centros = response.datosResult.datosListas
        } else {
          this.centros = [];
        }

        if (response?.mensajes?.length) {
          this.showErrorMessageOnSnackBar(response.mensajes, 'GetListados');
        }

    } catch (error) {
      console.info(`While loading centros de avisos en la web happend error ${error}`);
      this.centros = [];
    }
  }

  updateFormValues(formValues: { [key: string]: any }) {
    if (formValues) {
      const updatedFormValues = Object.keys(formValues).reduce((result, currKey) => {
        if (!result[currKey] && currKey !== 'FechaInicio' && currKey !== "FechaFin") {
          result[currKey] = formValues[currKey];
        }

        if (!result[currKey] && (currKey === 'FechaInicio' || currKey === 'FechaFin')) {
          result[currKey] = moment(formValues[currKey], 'DD-MM-YYYY').toDate();         

          if (currKey === 'FechaInicio' && formValues[currKey]) {
            this.fechaFV_minDesde = moment(formValues[currKey], 'DD-MM-YYYY').toDate();
          }
        }

        if (currKey === 'Idiomas' && formValues[currKey]) {
          const modifiedElementIdiomas: Idioma[] = typeof formValues[currKey] === 'string' ? JSON.parse(formValues[currKey] ?? "[]") : [];

          if (this.idiomas) {
            this.idiomas.forEach((idioma) => {
              this.lineas.forEach((linea) => {
                const getModifiedIdiomaValue = modifiedElementIdiomas.find((modifiedIdioma) => modifiedIdioma.CodIdioma === idioma.codIdioma)

                result[`${linea}_${idioma.codIdioma}`] = getModifiedIdiomaValue ? getModifiedIdiomaValue[linea] : '';
              })
            })
          }
        }

        if (currKey === 'ListaPlataformasSinTraduction') {
          if (formValues[currKey] && Array.isArray(formValues[currKey])) { 
            result['ListaPlataformas'] = formValues[currKey];
          }  else if (formValues[currKey] && typeof formValues[currKey] === 'string') {
            result['ListaPlataformas'] = JSON.parse(formValues[currKey]);
          } else {
            result['ListaPlataformas'] = [];
          }
        }

        return result;
      }, {})

      this.editRegistroForm.patchValue(updatedFormValues);
      this.formValues = updatedFormValues;
    }
  }

  valuedChanged() {
    this.editRegistroForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      console.log('form value: ', value)

      if (this.formValues) {
        this.panelService.setDiscardChanges(false);

        if (JSON.stringify(value) === JSON.stringify(this.formValues)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  submit() {
    this.editRegistroForm.markAllAsTouched();

    const formValues: { [key: string]: string } = this.editRegistroForm.value;
    const preparedPayload: Partial<GetCalendariosCuadrosMesLista> = this.getPreparedPayload(formValues);
    const userLang = localStorage.getItem('Language');

    try {
      const linea1ControlByUserLang = this.editRegistroForm.controls[`Linea1_${userLang}`];

      if (linea1ControlByUserLang && linea1ControlByUserLang.invalid) {
        const getAccardionLineaStepIndex = this.idiomas?.findIndex((idioma) => idioma.codIdioma === userLang);

        if (this.expansionPanelList) {
          this.expansionPanelList.forEach((ep, i) => {
            ep.close();

            if (i === this.closedAccordionIndex && i === getAccardionLineaStepIndex && ep.closed) {
              setTimeout(() => ep.open())
            }
          })
        }

        if (getAccardionLineaStepIndex !== this.closedAccordionIndex) {
          this.setLineaStep(getAccardionLineaStepIndex);
        }
      }
    } catch (error) {
      console.info(`could not to get Linea_${userLang} control from edit aviso web form`, error)
    }

    if (this.editRegistroForm.valid) {
      this.manageApi(preparedPayload, this.mode);
    }
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(null);
  }

  discard() {
    this.updateFormValues(this.formValues);
    this.editRegistroForm.markAllAsTouched();
  }

  manageApi(formValues: Partial<GetCalendariosCuadrosMesLista>, mode) {
    this.loading = true;

    switch (mode) {
      case "U":
        //update
        this.InsFormValues(formValues);
        break;
        
      default:
          formValues.pkId = '0';
          this.InsFormValues(formValues);
        break;
    }
  }
  
  InsFormValues(formValues: Partial<GetCalendariosCuadrosMesLista>) {
    this.conectarApiService.insUpdCalendariosCuadrosMes(formValues)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.nextWindow(response);
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  nextWindow(response: any) {
    const err = this.existErrors();
    if (!this.existErrors()) {
      this.save();
      this.destroy();
      this.showErrorMessageOnSnackBar(response.Mensajes, 'InsUpdCalendariosCuadrosMesError');
    }
  }

  showErrorMessageOnSnackBar(mensajes: Mensaje[], serviceName?: string): void {
    if (mensajes.length > 0) {
      mensajes.forEach((element) => {
        const description = serviceName ? this.translator[`${serviceName}${element.CodigoMensaje}`] : element.DescripcionMensaje;

        this.snackvar_service.openSnackBar(
          description ?? element.DescripcionMensaje,
          "",
          "red-snackbar",
          serviceName ? "" : element.CodigoMensaje
        );
      });
    } else {
      this.snackvar_service.openSnackBar(
        this.translation["MensajeSuccessSnackBar"],
        "",
        "green-snackbar"
      );
    }
  }

  getPreparedPayload(formValues: { [key: string]: string }):  Partial<GetCalendariosCuadrosMesLista> {
    let listaPlataformas = [{ Plataforma: '1' }];

    try {
      if (typeof formValues['ListaPlataformas'] === 'string') {
        listaPlataformas = JSON.parse(formValues['ListaPlataformas'] ?? "")
      }

      if (Array.isArray(formValues['ListaPlataformas'])) {
        listaPlataformas = formValues['ListaPlataformas'].map((plataformaNumber) => ({ Plataforma: plataformaNumber }));
      }
      
    } catch (error) {
      listaPlataformas = [{ Plataforma: '1' }];
    }

    const getIdiomas: Idioma[] = this.getBodyIdiomas(formValues);
    const getPoryectLang = localStorage.getItem('Language') ?? '';
    const getLineasFormValueBasedOnProyectLang: Idioma = getIdiomas.find(idioma => idioma.CodIdioma === getPoryectLang) ?? {
      CodIdioma: "",
      Linea1: "",
      Linea2: "",
      Linea3: ""
    }

    const body: Omit<GetCalendariosCuadrosMesLista, 'NombreCentro'> = {
      pkId: formValues['pkId'] ?? "",
      FechaInicio: moment(formValues['FechaInicio'], 'DD-MM-YYYY').format('YYYY/MM/DD') ?? "",
      FechaFin:  moment(formValues['FechaFin'], 'DD-MM-YYYY').format('YYYY/MM/DD') ?? "",
      Linea1: getLineasFormValueBasedOnProyectLang.Linea1 || formValues['Linea1']?.trim() || "",
      Linea2: getLineasFormValueBasedOnProyectLang.Linea2  || formValues['Linea2']?.trim()  || "",
      Linea3: getLineasFormValueBasedOnProyectLang.Linea3  || formValues['Linea3']?.trim()  || "",
      Imagen: "",
      Idiomas: getIdiomas,
      ListaPlataformas: listaPlataformas,
      ClaveCentro:formValues['ClaveCentro'] ?? ""
    };

    return body;
  }

  getBodyIdiomas(formValues: { [key: string]: string }): Idioma[] {
    const mapIdiomas: Map<string, Idioma> = new Map();

    Object.keys(formValues).forEach((key) => {
      // match if key is Linea1_ or Linea2_ etc.
      if (/Linea\d_.+/.test(key)) {
        const idioma: Idioma = {
          CodIdioma: "",
          Linea1: "",
          Linea2: "",
          Linea3: ""
        };
        const [linea, codIdioma] = key.split('_');

        if (formValues[key] && !mapIdiomas.has(codIdioma)) {
          idioma[linea] = formValues[key]?.trim();
          idioma.CodIdioma = codIdioma;
          mapIdiomas.set(codIdioma, idioma);
        }

        if (formValues[key] && mapIdiomas.has(codIdioma)) {
          const getMapIdioma = mapIdiomas.get(codIdioma);
          
          getMapIdioma[linea] = formValues[key]?.trim();
          mapIdiomas.set(codIdioma, getMapIdioma);
        }
      }
    })

    return Array.from(mapIdiomas.values());
  }
  
  setLineaStep(index: number): void {
    this.lineaPanelStep = index;
  }

  closedAccordion(i: number) {
    this.closedAccordionIndex = i;
  }

  aFechaddmmyyyy(fecha: string): Date {
    if (fecha == null || fecha.length == 0) {
      return null;
    } else {
      var parts = fecha.split("/");
      if (parts[0] != "Invalid date") {
        return new Date(
          parseInt(parts[2].substring(0, 4)),
          parseInt(parts[1]) - 1,
          parseInt(parts[0])
        );
      } else {
        return null;
      }
    }
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  }  

  async getIdiomas(): Promise<void> {
    try {
      if (this.idiomasCacheMap.has('idiomas')) {
        this.idiomas = this.idiomasCacheMap.get('idiomas');
      } else {
        const response = await this.microService.getIdiomasWithMicroservice({ activo: '1' }).toPromise();

        if (response?.listaIdiomas?.length) {
          this.idiomas = response.listaIdiomas.map((idioma) => ({ nombre: idioma.nombre, codIdioma: idioma.codIdioma }))
          this.idiomasCacheMap.set('idiomas', this.idiomas);
        } else {
          this.idiomas = [];
          this.idiomasCacheMap.delete('idiomas');
        }
      }
    } catch (error) {
      console.info(`While loading idiomas happend error ${error}`);
      this.idiomas = [];
      this.idiomasCacheMap.delete('idiomas');
    }
  }  

  existErrors() {
    return this.editRegistroForm.get("pkId").errors
  }

  getErrorMessage(field: string) {
    const control = this.editRegistroForm.get(field);
    let errorMessage = 'Error'

    if (control && control.errors) {
      if (control.errors.required) {
        return this.translation["CampoRequerido"];
      }

      switch (field) {
        case "Nombre":
          if (control.hasError("pattern")) {
            errorMessage = this.translation["SoloLetras"];
          }
          break;

        default:
          break;
      }
    }

    return errorMessage;
  }

  validateFields(field: string) {
    return this.isValidAnyField(field);
  }

  isValidAnyField(field: string) {
    let fc_pv = this.editRegistroForm.controls;
    return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
  }
}
